module.exports = __webpack_public_path__ + "img/bh.4bc0dacd.svg";